import { observable, action, configure } from 'mobx';

configure({ enforceActions: 'observed' });

const sidebarIsOpen = localStorage.getItem('sidebarIsOpen');

class LayoutStore {
  @observable isDrawerOpen: boolean = (sidebarIsOpen == null) ? true : JSON.parse(sidebarIsOpen);

  @observable confirmModal: any = null;

  @observable alert: any = null;

  @action.bound
  setDrawerOpen (open: boolean) {
    this.isDrawerOpen = open;
    localStorage.setItem('sidebarIsOpen', JSON.stringify(open));
  }

  @action.bound
  setConfirmModal (confirm: any) {
    this.confirmModal = confirm;
  }

  @action.bound
  setAlert (alert: any) {
    this.alert = alert;
  }
}

export default new LayoutStore();
